import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import * as ko from "knockout";
import {Application} from "../application";

export class ShowEstimateDoubleSpaceLinesCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.ShowEstimateDoubleSpaceLines;

    canExecute = ko.computed(() => {
        return !!this.app.state.estimate();
    });

    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });

    execute(): JQueryPromise<any> {
        let dfd = $.Deferred();

        if (!this.canExecute())
            return dfd.reject().promise();

        this.app.state.estimateGridDoubleSpaceLines(!this.app.state.estimateGridDoubleSpaceLines());
        
        return dfd.resolve().promise();
    }
    
    name = "Show Estimate Double Space Lines"
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/showEstimateDoubleSpaceLines.ts